/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import "./Job.css";
import ButtonCustom from "../../components/button/ButtonCustom";
import axios from "axios";
import Select2 from "react-select";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import validator from "validator";
import $ from "jquery";
import {
  checkEditPage,
  popupErrorApi,
  update_tracking,
  REQUIRE_WORKPLACE,
  REQUIRE_BUSINESS_TYPE,
} from "../../components/helpers/Helpers";
import { IMaskInput } from "react-imask";
import Loading from "../../components/loading/loading";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import to from "await-to-js";
import ktbsApi from "./../../api";
import { config } from "./../../constants";
import { isMobile } from "react-device-detect";
import BannerContentLeft from "../../components/BannerContentLeft/BannerContentLeft";

const _url = config.baseAPIURL03;

class Jobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      business_type: [],
      career_type: [],
      income_type: [],
      RetrieveData: [],
      f3_income: [],
      f1_career: [],
      f1_business_type: [],
      f1_etc: "",
      f1_business_other: "",
      f1_career_other: "",
      f1_career_position: "",
      f3_officename: "",
      loading: true,
      isSubmit: false,
      AutoFlag: false,
      isDisconnected: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async componentDidMount() {
    await this.setState({ loading: true });

    const arr_jobs_data = await JSON.parse(
      localStorage.getItem("arr_jobs_data"),
    );

    // โหลด business_type
    await axios
      .get(_url + `/constant/business_type`)
      .then((res) => {
        const business_type = res.data.Data.map((item) => {
          if (arr_jobs_data && item.Id === arr_jobs_data.f1_business_type) {
            this.setState({
              f1_business_type: {
                value: item.Id,
                label: item.ThName,
                Other: item.Other,
                RiskGroup: item.RiskGroup,
              },
              f1_business_other: arr_jobs_data.f1_business_other,
            });
          }
          return {
            value: item.Id,
            label: item.ThName,
            Other: item.Other,
            RiskGroup: item.RiskGroup,
          };
        });
        this.setState({ business_type });
      })
      .catch(async (error) => {
        const { title_mss, mss } = this.parseApiError(error);
        popupErrorApi(mss, title_mss, true);
        this.setState({ loading: false });
      });

    // โหลด career
    await axios
      .get(_url + `/constant/career`)
      .then((res) => {
        const career_type = res.data.Data.map((item) => {
          if (arr_jobs_data && item.Id === arr_jobs_data.f1_career) {
            this.setState({
              f1_career: {
                value: item.Id,
                label: item.ThName,
                type: item.SAmcr_Type,
                Other: item.Other,
                RiskGroup: item.RiskGroup,
                HideCase: item.HideCase, // ← เก็บ HideCase จาก API
              },
              AutoFlag: item.AutoFlag === 1,
              f1_career_other: arr_jobs_data.f1_career_other,
            });
          }
          return {
            value: item.Id,
            label: item.ThName,
            autoflag: item.AutoFlag,
            type: item.SAmcr_Type,
            Other: item.Other,
            RiskGroup: item.RiskGroup,
            HideCase: item.HideCase, // ← เก็บ HideCase จาก API
          };
        });
        this.setState({ career_type });
      })
      .catch(async (error) => {
        const { title_mss, mss } = this.parseApiError(error);
        popupErrorApi(mss, title_mss, true);
        this.setState({ loading: false });
      });

    // โหลด income
    await axios
      .get(_url + `/constant/income`)
      .then((res) => {
        const income_type = res.data.Data.map((item) => {
          if (arr_jobs_data && item.Id === arr_jobs_data.f3_income) {
            this.setState({
              f3_income: { value: item.Id, label: item.ThName },
            });
          }
          if (arr_jobs_data) {
            this.setState({
              f1_career_position: arr_jobs_data.f1_career_position || "",
              f3_officename: arr_jobs_data.f3_officename || "",
            });
          }
          return { value: item.Id, label: item.ThName };
        });
        this.setState({ income_type });
      })
      .catch(async (error) => {
        const { title_mss, mss } = this.parseApiError(error);
        popupErrorApi(mss, title_mss, true);
        this.setState({ loading: false });
      });

    await this.setState({ loading: false });
  }

  // helper: parse axios error → { title_mss, mss }
  parseApiError(error) {
    if (!!error.isAxiosError && !error.response) {
      return {
        title_mss: "เกิดข้อผิดพลาด",
        mss: "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
      };
    }
    return {
      title_mss:
        error.response?.data?.Data?.[0]?.[0]?.MsgDescTitle || "เกิดข้อผิดพลาด",
      mss:
        error.response?.data?.Data?.[0]?.[0]?.MsgDesc ||
        "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
    };
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isSubmit: true });

const { requireWorkplace, requireBusinessType } = this.getCareerFlags();

    let isValid = await this.validate();

    // ตรวจ RiskGroup 3 → บล็อกทันที
    if (
      this.state.f1_career.RiskGroup === 3 ||
      this.state.f1_business_type.RiskGroup === 3
    ) {
      isValid = false;
      const HeaderManp = JSON.parse(localStorage.getItem("HeaderManp"));
      const checkuserinfo = JSON.parse(localStorage.getItem("checkuserinfo"));
      const data = {
        head_token: HeaderManp.head_token,
        card_id: checkuserinfo ? checkuserinfo.cardId : "",
        stamp_page: "3",
        error_code: "3002",
      };
      const update_tracking_send = await update_tracking(data);
      if (update_tracking_send.success) {
        popupErrorApi(
          "ขออภัยท่านไม่สามารถเปิดบัญชีออนไลน์ได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800",
          "เกิดข้อผิดพลาด",
          true,
        );
      }
    }

    if (isValid) {
      await this.setState({ loading: true });
      // อัปเดต f3 income
      const f3 = JSON.parse(localStorage.getItem("f3"));
      const f3_ = {
        f3_source: f3 ? f3.f3_source : "",
        f3_source_text: f3 ? f3.f3_source_text : "",
        f3_by_private_business: f3 ? f3.f3_by_private_business : "",
        f3_by_employee: f3 ? f3.f3_by_employee : "",
        f3_by_heritage: f3 ? f3.f3_by_heritage : "",
        f3_by_borrowing: f3 ? f3.f3_by_borrowing : "",
        f3_by_divided: f3 ? f3.f3_by_divided : "",
        f3_by_retired: f3 ? f3.f3_by_retired : "",
        f3_by_saving: f3 ? f3.f3_by_saving : "",
        f3_by_other: f3 ? f3.f3_by_other : "",
        f3_by_other_text: f3 ? f3.f3_by_other_text : "",
        f3_income: this.state.f3_income.value,
        f3_outcome: f3 ? f3.f3_outcome : "",
        f3_invest: f3 ? f3.f3_invest : "",
        f3_valuable: f3 ? f3.f3_valuable : "",
        f3_by_invest: f3 ? f3.f3_by_invest : "0",
        f3_own: f3 ? f3.f3_own : "1",
        purpose_json: f3 ? f3.purpose_json : [],
        HideCase: this.state.f1_career?.HideCase
      };
      localStorage.setItem("f3", JSON.stringify(f3_));

      const arr_jobs_data = {
        f1_career: this.state.f1_career.value,
        f1_business_type: requireBusinessType
          ? this.state.f1_business_type.value
          : "",
        f1_business_other:
          requireBusinessType && this.state.f1_business_type.Other === 1
            ? validator.trim(this.state.f1_business_other)
            : "",
        f1_career_other:
          this.state.f1_career.Other === 1
            ? validator.trim(this.state.f1_career_other)
            : "",
        f3_income: this.state.f3_income.value,
        f1_career_position: requireWorkplace
          ? validator.trim(this.state.f1_career_position)
          : "",
        f3_officename: requireWorkplace
          ? validator.trim(this.state.f3_officename)
          : "",
      };
      localStorage.setItem("arr_jobs_data", JSON.stringify(arr_jobs_data));

      const str = window.location.href;
      const back_to_edit = /edit/.test(str);

      if (back_to_edit) {
        let error;
        let result;
        let mss = "";
        let title_mss = "";
        const MySwal = withReactContent(swal);
        const HeaderManp = JSON.parse(localStorage.getItem("HeaderManp"));
        const head_token = HeaderManp.head_token;
        const f3Saved = JSON.parse(localStorage.getItem("f3")) || {};
        const jobsSaved =
          JSON.parse(localStorage.getItem("arr_jobs_data")) || {};

        const {
          f3_source,
          f3_source_text,
          f3_by_private_business,
          f3_by_employee,
          f3_by_heritage,
          f3_by_borrowing,
          f3_by_divided,
          f3_by_retired,
          f3_by_saving,
          f3_by_other,
          f3_by_other_text,
          f3_income: savedIncome,
          f3_outcome,
          f3_invest,
          f3_valuable,
          purpose_json,
          f3_by_invest,
          f3_own,
        } = f3Saved;

        const {
          f1_business_other,
          f1_business_type,
          f1_career: savedCareer,
          f1_career_other,
          f1_career_position,
          f3_officename: savedOfficename,
        } = jobsSaved;

        const careerAndFinancial = {
          head_token,
          f3_source,
          f3_source_text,
          f3_by_private_business,
          f3_by_employee,
          f3_by_heritage,
          f3_by_borrowing,
          f3_by_divided,
          f3_by_retired,
          f3_by_saving,
          f3_by_other,
          f3_by_other_text,
          f3_income: savedIncome,
          f3_outcome,
          f3_invest,
          f3_valuable,
          purpose_json,
          f3_career: savedCareer,
          f3_officename: savedOfficename,
          f3_career_text: f1_career_other,
          f3_business: requireBusinessType ? f1_business_type : "",
          f3_business_text: f1_business_other,
          f3_position: f1_career_position,
          f3_by_invest,
          f3_own,
        };

        [error, result] = await to(
          ktbsApi.post("/form/career_and_financial/manp", careerAndFinancial),
        );

        if (
          error ||
          !result ||
          !result.Data ||
          !result.Data[0] ||
          !result.Data[0][0] ||
          result.Data[0][0].IsSuccess !== 1
        ) {
          if (result) {
            title_mss = result.Data[0][0].MsgDescTitle || "เกิดข้อผิดพลาด";
            mss =
              result.Data[0][0].MsgDesc ||
              "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
          } else if (error) {
            const parsed = this.parseApiError(error);
            title_mss = parsed.title_mss;
            mss = parsed.mss;
          } else {
            title_mss = "เกิดข้อผิดพลาด";
            mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
          }
          MySwal.fire({
            imageUrl: "/images/ico_alert.svg",
            imageWidth: 100,
            imageHeight: 100,
            customClass: { confirmButton: "long_btn_fix" },
            confirmButtonColor: "#003b66",
            confirmButtonText: "กลับ",
            title: '<div class="title_popup">' + title_mss + "</div>",
            html: '<div class="content_popup">' + mss + "</div>",
          });
          await this.setState({ loading: false });
          return;
        }

        await this.setState({ loading: false });
        await this.props.history.push("/summaryshow");
        await localStorage.setItem("editPage", "Jobs");
        return;
      }

      const BackToSummaryRisk = JSON.parse(
        localStorage.getItem("BackToSummaryRisk"),
      );
      if (BackToSummaryRisk) {
        localStorage.removeItem("BackToSummaryRisk");
        window.location = "summary_risk";
      } else {
        this.props.history.push("/FamilyStatus");
      }
    }
  };

  handleChange = async (selectedOption, e) => {
    await this.setState({ [e.name]: selectedOption });

    if (selectedOption.Other === 0) {
      this.setState({ f1_etc: "" });
    }

    if (e.name === "f1_career") {
      await this.setState({
        AutoFlag: selectedOption.autoflag === 1,
        f1_business_type: [],
        f1_business_other: "",
        f3_officename: "",
        f1_career_position:
          selectedOption.HideCase === "001"
            ? ""
            : selectedOption.autoflag === 1
              ? selectedOption.label
              : "",
      });
    }

    if (this.state.isSubmit) {
      await this.validate();
    }
  };

  validate = () => {
    $("span[class^=span_f]").hide();
    let countError = 0;

const { requireWorkplace, requireBusinessType } = this.getCareerFlags();

    // อาชีพ (บังคับทุกคน)
    if (!this.state.f1_career.value) {
      $(".span_f1_career").css("display", "flex");
      countError++;
    }

    // อาชีพอื่นๆ (เฉพาะเมื่อ Other === 1)
    if (!this.state.f1_career_other && this.state.f1_career.Other === 1) {
      $(".span_f1_etc_job").css("display", "flex");
      countError++;
    }

    // ประเภทธุรกิจ (เฉพาะอาชีพใน REQUIRE_BUSINESS_TYPE)
    if (requireBusinessType && !this.state.f1_business_type.value) {
      $(".span_f1_business_type").css("display", "flex");
      countError++;
    }

    // ธุรกิจอื่นๆ (เฉพาะเมื่อ Other === 1)
    if (
      requireBusinessType &&
      !this.state.f1_business_other &&
      this.state.f1_business_type.Other === 1
    ) {
      $(".span_f1_etc").css("display", "flex");
      countError++;
    }

    // รายได้ต่อเดือน (บังคับทุกคน)
    if (!this.state.f3_income.value) {
      $(".span_f3_income").css("display", "flex");
      countError++;
    }

    // ตำแหน่งงาน (เฉพาะอาชีพใน REQUIRE_WORKPLACE)
    if (requireWorkplace && !this.state.f1_career_position) {
      $(".span_f1_career_position").css("display", "flex");
      countError++;
    }

    // สถานที่ทำงาน (เฉพาะอาชีพใน REQUIRE_WORKPLACE)
    if (requireWorkplace && !this.state.f3_officename) {
      $(".span_f3_officename").css("display", "flex");
      countError++;
    }

    return countError === 0;
  };
// helper ตรวจสอบจาก HideCase
getCareerFlags = () => {
  const hideCase = this.state.f1_career?.HideCase;
  return {
    requireWorkplace: hideCase === "002" || hideCase === "003",
    requireBusinessType: hideCase === "003",
  };
};
  handleIChange = async (v, ref) => {
    await this.setState({ [ref.el.input.name]: v });
    if (this.state.isSubmit) {
      await this.validate();
    }
  };

  goback = () => {
    if (checkEditPage()) return;
    this.props.history.push("/idc_address_choose");
  };

  render() {
    library.add(fas);

    const { requireWorkplace, requireBusinessType } = this.getCareerFlags();

    return (
      <div className={isMobile ? "" : "body"}>
        <header
          className={isMobile ? "" : "header-area"}
          style={{ display: isMobile ? "none" : "block" }}
        >
          <div className="container everest-nav-container">
            <div className="row">
              <div className="col-md-6">
                <img src="../../../images/logo.png" alt="logo" />
              </div>
              <div className="col-md-6 flex_end">
                <div className="text-branding">บริการเปิดบัญชีออนไลน์</div>
              </div>
            </div>
          </div>
        </header>

        <section
          className={isMobile ? "" : "desktop_content section-gap-full"}
          style={{ backgroundImage: isMobile ? "none" : "url(/images/bg.jpg)" }}
        >
          <div className={isMobile ? "" : "container"}>
            <div className={isMobile ? "" : "row"}>
              <div
                className="col-md-6"
                style={{ display: isMobile ? "none" : "block" }}
              >
                <BannerContentLeft />
              </div>

              <div className={isMobile ? "" : "col-md-6"}>
                <div className="content">
                  <Loading status={this.state.loading} />

                  <div className="top_main_back">
                    <div className="main_back" onClick={this.goback}>
                      <img
                        src={
                          isMobile
                            ? "/images/angle-arrow-left.svg"
                            : "/images/angle-arrow-left-blue.svg"
                        }
                        style={{
                          display: checkEditPage() ? "none" : "block",
                          marginLeft: "3px",
                        }}
                        className="arrow_back"
                        alt="back"
                      />
                    </div>
                    <div className="text_title">ข้อมูลอาชีพ</div>
                  </div>

                  <div className="bg_content_white over_f_hide">
                    <div
                      className="in_bg_white autoscroll"
                      style={{ top: 0, padding: "0 21px", left: 0, right: 0 }}
                    >
                      {/* อาชีพ */}
                      <div
                        className="row_idcard"
                        style={{
                          borderColor:
                            this.state.f1_career.value !== undefined
                              ? "#003b66"
                              : "#ccc",
                        }}
                      >
                        <div>อาชีพ *</div>
                        <Select2
                          name="f1_career"
                          options={this.state.career_type}
                          value={this.state.f1_career}
                          onChange={this.handleChange}
                          placeholder="กรุณาระบุ"
                          className="select_two"
                        />
                        <span className="span_f1_career">กรุณาระบุอาชีพ</span>
                      </div>

                      {/* อาชีพอื่นๆ */}
                      {this.state.f1_career.Other === 1 && (
                        <div
                          className="row_idcard"
                          style={{
                            borderColor:
                              this.state.f1_career_other === ""
                                ? "#ccc"
                                : "#003b66",
                          }}
                        >
                          <div>อาชีพ อื่นๆ *</div>
                          <IMaskInput
                            mask={new RegExp("^[A-Za-zก-๙.\\s\\-/]+$")}
                            value={this.state.f1_career_other}
                            unmask={true}
                            className="input_idcard"
                            name="f1_career_other"
                            style={{
                              textDecorationLine: "none",
                              borderColor:
                                this.state.f1_career_other !== ""
                                  ? "#003b66"
                                  : "#ccc",
                            }}
                            onAccept={this.handleIChange}
                          />
                          <span className="span_f1_etc_job">
                            กรุณาระบุอาชีพอื่นๆ
                          </span>
                        </div>
                      )}

                      {/* ประเภทธุรกิจ (เฉพาะอาชีพใน REQUIRE_BUSINESS_TYPE) */}
                      {requireBusinessType && (
                        <div
                          className="row_idcard"
                          style={{
                            borderColor:
                              this.state.f1_business_type.value !== undefined
                                ? "#003b66"
                                : "#ccc",
                          }}
                        >
                          <div>ประเภทธุรกิจ *</div>
                          <Select2
                            name="f1_business_type"
                            options={this.state.business_type}
                            value={this.state.f1_business_type}
                            onChange={this.handleChange}
                            placeholder="กรุณาระบุ"
                            className="select_two"
                          />
                          <span className="span_f1_business_type">
                            กรุณาระบุประเภทธุรกิจ
                          </span>
                        </div>
                      )}

                      {/* ธุรกิจอื่นๆ */}
                      {requireBusinessType &&
                        this.state.f1_business_type.Other === 1 && (
                          <div
                            className="row_idcard"
                            style={{
                              borderColor:
                                this.state.f1_business_other === ""
                                  ? "#ccc"
                                  : "#003b66",
                            }}
                          >
                            <div>ธุรกิจ อื่นๆ *</div>
                            <IMaskInput
                              mask={new RegExp("^[A-Za-zก-๙.\\s\\-/]+$")}
                              value={this.state.f1_business_other}
                              unmask={true}
                              className="input_idcard"
                              name="f1_business_other"
                              style={{
                                textDecorationLine: "none",
                                borderColor:
                                  this.state.f1_business_other !== ""
                                    ? "#003b66"
                                    : "#ccc",
                              }}
                              onAccept={this.handleIChange}
                            />
                            <span className="span_f1_etc">
                              กรุณาระบุธุรกิจอื่นๆ
                            </span>
                          </div>
                        )}

                      {/* รายได้ต่อเดือน */}
                      <div
                        className="row_idcard"
                        style={{
                          borderColor:
                            this.state.f3_income.value !== undefined
                              ? "#003b66"
                              : "#ccc",
                        }}
                      >
                        <div>รายได้ต่อเดือน(บาท) *</div>
                        <Select2
                          name="f3_income"
                          options={this.state.income_type}
                          value={this.state.f3_income}
                          onChange={this.handleChange}
                          isSearchable={false}
                          placeholder="กรุณาระบุ"
                          className="select_two"
                        />
                        <span className="span_f3_income">
                          กรุณาระบุรายได้ต่อเดือน
                        </span>
                      </div>

                      {/* ตำแหน่งงาน (เฉพาะอาชีพใน REQUIRE_WORKPLACE) */}
                      {requireWorkplace && (
                        <div
                          className="row_idcard"
                          style={{
                            borderColor:
                              this.state.f1_career_position === ""
                                ? "#ccc"
                                : "#003b66",
                          }}
                        >
                          <div>ตำแหน่งงาน *</div>
                          <IMaskInput
                            mask={new RegExp("^[A-Za-zก-๙.\\s\\-/]+$")}
                            value={this.state.f1_career_position}
                            unmask={true}
                            className="input_idcard"
                            disabled={this.state.AutoFlag}
                            name="f1_career_position"
                            style={{
                              textDecorationLine: "none",
                              color: this.state.AutoFlag ? "#ccc" : "#003b66",
                              borderColor:
                                this.state.f1_career_position !== ""
                                  ? "#003b66"
                                  : "#ccc",
                            }}
                            onAccept={this.handleIChange}
                          />
                          <span className="span_f1_career_position">
                            กรุณาระบุตำแหน่งงาน
                          </span>
                        </div>
                      )}

                      {/* ชื่อสถานที่ทำงาน (เฉพาะอาชีพใน REQUIRE_WORKPLACE) */}
                      {requireWorkplace && (
                        <div
                          className="row_idcard"
                          style={{
                            borderColor:
                              this.state.f3_officename === ""
                                ? "#ccc"
                                : "#003b66",
                          }}
                        >
                          <div>ชื่อสถานที่ทำงาน *</div>
                          <IMaskInput
                            mask={/^[A-Za-zก-๙1-9\\(\\),.@&\s'-]+$/}
                            value={this.state.f3_officename}
                            unmask={true}
                            className="input_idcard"
                            name="f3_officename"
                            style={{
                              textDecorationLine: "none",
                              borderColor:
                                this.state.f3_officename !== ""
                                  ? "#003b66"
                                  : "#ccc",
                            }}
                            onAccept={this.handleIChange}
                          />
                          <span className="span_f3_officename">
                            กรุณาระบุชื่อสถานที่ทำงาน
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="under_fix_btn">
                      <ButtonCustom
                        handle={this.handleSubmit}
                        label={checkEditPage() ? "บันทึกการแก้ไข" : "ถัดไป"}
                        color="blue"
                        btnClass="long_btn"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Jobs;
